import pako from "pako";
import { state } from "../settings";

const splitState = "config=";

export function encodeStateToURL() {
  const stateCopy = {
    tp: state.typePergola,
    rt: state.roofType,
    ro: state.retractOption,
    lt: state.louvreType,
    ps: state.postSize,
    rz: state.currentRotationZ,
    h: state.height,
    l: state.length,
    w: state.width,
    bw: state.backWall ? 1 : 0,
    cr: state.colorRoof,
    cb: state.colorBody,
    cd: state.colorSladditec,
    ch: state.colorShutters,
    cz: state.colorZip,
    dm: state.dayMode ? 1 : 0,
    dr: state.directionRoof,
    rc: state.roofColorType,
    zi: state.zipInput,
    sd: state.slidingDoorInput,
    si: state.slidingShuttersInput,
    lo: state.louversOpeningInput,
    ss: [...state.subSystem],
    su: [...state.subSystemUrl],
    e: [...state.electro],
    rl: state.recessedLighting,
  };

  const jsonString = JSON.stringify(stateCopy);
  const compressed = pako.deflate(jsonString);

  let binary = '';
  for (let i = 0; i < compressed.length; i++) {
    binary += String.fromCharCode(compressed[i]);
  }
  return btoa(binary);
}

export function decodeURLToState(encoded) {
  try {
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    const decompressed = pako.inflate(bytes, { to: 'string' });
    const d = JSON.parse(decompressed);

    return {
      typePergola: d.tp,
      roofType: d.rt,
      retractOption: d.ro,
      louvreType: d.lt,
      postSize: d.ps,
      currentRotationZ: d.rz,
      height: d.h,
      length: d.l,
      width: d.w,
      backWall: d.bw === 1,
      colorRoof: d.cr,
      colorBody: d.cb,
      colorSladditec: d.cd,
      colorShutters: d.ch,
      colorZip: d.cz,
      dayMode: d.dm === 1,
      directionRoof: d.dr,
      roofColorType: d.rc,
      zipInput: d.zi,
      slidingDoorInput: d.sd,
      slidingShuttersInput: d.si,
      louversOpeningInput: d.lo,
      subSystem: new Set(d.ss || []),
      subSystemUrl: new Set(d.su || []),
      electro: new Set(d.e || []),
      recessedLighting: d.rl,
    };
  } catch (error) {
    console.error('Error decoding state:', error);
    return {};
  }
}

export function changeURL() {
  const url = encodeStateToURL();
  const newUrl = `${window.location.origin}${window.location.pathname}?${splitState}${url}`;
  history.pushState({}, '', newUrl);
}

export function initURLSystem() {
  // no-op, defaults snapshot not needed with explicit mapping
}

export async function initStateFromUrl() {
  const urlParams = window.location.search;
  const idx = urlParams.indexOf(splitState);
  if (idx === -1) return null;

  const stateParam = urlParams.substring(idx + splitState.length);
  if (!stateParam) return null;

  try {
    const decodedState = decodeURLToState(stateParam);
    Object.assign(state, decodedState);
    return decodedState;
  } catch (error) {
    console.error('Error loading state from URL:', error);
    return null;
  }
}